const Style = {
    stack: 'space-y-6',
    header: 'text-center lg:text-left',
    title: 'text-2xl font-bold text-text-primary',
    description: 'mt-1 text-sm text-text-secondary',
    footer: 'text-center text-sm text-text-secondary lg:text-left',
};

export default Style;
